import { styled } from 'goober';

import { colors } from '@/theme/colors';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { ParagraphMedium } from '@/ui/typography/widgets';

interface EmptyStateProps {
  message: string;
}

export const EmptyState = ({ message }: EmptyStateProps) => {
  return (
    <Container justify="center" alignItems="center">
      <ParagraphMedium color={colors.gray.c11}>{message}</ParagraphMedium>
    </Container>
  );
};

const Container = styled(Flexbox)`
  height: 100%;
`;
